import React__default from 'react';
import { useTable } from '../utils/hooks.js';
import { getRowGroupDataByExpandedField, getUniqueGroupValuesByField } from '../utils/rowUtils.js';
import { updateSortForColumn, sortData } from '../utils/sortUtils.js';
import RecursiveRowGroups from './RecursiveRowGroups.js';

/**
 * Row Groups - This component provides data to the child or terminates recursion at the row group level
 * @param {object} props
 * @param {Array<{ field: string}>} props.columnDefs the column definitions
 * @param {number} props.childRowGroupIndex the column def index of the child row group
 * @param {string} props.classesForColumns classes from columnDefs passed to cells
 * @param {string} props.id unique id passed from and related to parent
 * @param {boolean} props.isChildRowGroup
 * @param {any} props.parentRows rows that are generated from the parent
 * @param {any} props.parentRowGroupIndex created from the index order of a column def
 * @param {any} props.expandedRowGroup
 * @returns {any}
 */

function RowGroups(_ref) {
  var columnDefs = _ref.columnDefs,
    childRowGroupIndex = _ref.childRowGroupIndex,
    classesForColumns = _ref.classesForColumns,
    id = _ref.id,
    isChildRowGroup = _ref.isChildRowGroup,
    parentRows = _ref.parentRows,
    parentRowGroupIndex = _ref.parentRowGroupIndex,
    expandedRowGroup = _ref.expandedRowGroup,
    groupId = _ref.groupId;
  var _useTable = useTable(),
    columns = _useTable.state.columns;

  // Do not render if parent is not expanded
  // Do not render if not a row group
  if (!expandedRowGroup && !isChildRowGroup) {
    return null;
  }

  // Get row group data
  var childRowGroupData = getRowGroupDataByExpandedField(parentRows, columnDefs[parentRowGroupIndex].field, expandedRowGroup);

  // Get unique row groups
  var childRowGroupDisplayData = getUniqueGroupValuesByField(childRowGroupData, columnDefs[childRowGroupIndex].field);

  // Update columns sort rules
  var sortColumnToUse = updateSortForColumn(columns.columnDefs, childRowGroupIndex, 'asc');

  // Sort Data
  var rowGroupData = sortData(childRowGroupDisplayData, [sortColumnToUse]);
  return rowGroupData.map(function (item, rowGroupIndex) {
    //used for keys
    var updatedId = "".concat(id, "-").concat(rowGroupIndex);
    var updatedGroupDescription = groupId + "-".concat(item[columnDefs[childRowGroupIndex].field].toString());
    return /*#__PURE__*/React__default.createElement(RecursiveRowGroups, {
      classesForColumns: classesForColumns,
      groupId: updatedGroupDescription,
      id: updatedId,
      key: "".concat(item[columnDefs[childRowGroupIndex].field]),
      childRowGroupData: childRowGroupData,
      parentRows: childRowGroupData,
      parentValue: item[columnDefs[childRowGroupIndex].field],
      parentRowGroupIndex: childRowGroupIndex ? childRowGroupIndex : null
    });
  });
}

export { RowGroups as default };
